import React from 'react'
import { Box } from '@mui/material'
import { WherebyProvider } from '@whereby.com/browser-sdk/react'
import { WherebyFloatCardView } from '../../../../../../pure-js/enums/Whereby'
import { WherebyCallSurface } from '../../components/whereby/WherebyCallSurface'
import { WherebyCallBlockedPanel } from '../../components/whereby/WherebyCallBlockedPanel'
import { WherebyFloatPreparingRoom, WherebyMediaBlockedPanel } from '../../components/whereby/globalWherebyFloatParts'
import { useWherebyConnectionKey } from '../../components/whereby/wherebyCallReconnect'
import { SprintCallPageLayout } from './SprintCallPageLayout'
import { sprintCallContentSx } from './sprintCallPageStyles'
import { useSprintCallPage } from './useSprintCallPage'

/** The introduction or a group reflection: one call for everyone in the sprint, on a page of its own. */
export const SprintCallPage: React.FC = () => {
  const page = useSprintCallPage()
  const callRoomUrl = page.view === WherebyFloatCardView.CALL ? page.roomUrl : undefined
  const isRoomReady = !!callRoomUrl && !!page.userId
  const { connectionKey, startFreshConnection } = useWherebyConnectionKey(callRoomUrl)

  const renderCall = (): React.ReactNode => {
    if (page.view === WherebyFloatCardView.ASK) {
      return (
        <WherebyCallBlockedPanel
          status={page.ownership.status}
          onConfirmTakeover={page.ownership.confirmTakeover}
          onRetry={page.ownership.retry}
          onCancel={page.leave}
        />
      )
    }
    if (!isRoomReady) {
      return (
        <WherebyFloatPreparingRoom
          isTakingTooLong={page.isTakingTooLong}
          onRetry={page.retryRoom}
          onLeaveCall={page.leave}
        />
      )
    }
    if (page.isMediaBlocked) return <WherebyMediaBlockedPanel onLeaveCall={page.leave} />

    return (
      <WherebyProvider key={connectionKey}>
        <WherebyCallSurface
          roomUrl={callRoomUrl}
          userId={page.userId}
          displayName={page.displayName}
          teamName={page.callName}
          onReconnect={startFreshConnection}
          onLeaveCall={page.leave}
          canShareScreen={true}
        />
      </WherebyProvider>
    )
  }

  return (
    <SprintCallPageLayout title={page.title}>
      <Box sx={sprintCallContentSx}>{renderCall()}</Box>
    </SprintCallPageLayout>
  )
}
